import { useLayoutEffect } from 'react'

/**
 * Grounds the page in a surface other than the default `surface-1`.
 *
 * Sets `--page-ground` on <html> for as long as the page is mounted, so the
 * body and the fixed navbar paint the same surface as the page content.
 *
 * @param {string} surface - a surface token name, e.g. 'surface-2'
 */
const usePageGround = (surface) => {
  useLayoutEffect(() => {
    const root = document.documentElement
    root.style.setProperty('--page-ground', `var(--color-${surface})`)
    return () => {
      root.style.removeProperty('--page-ground')
    }
  }, [surface])
}

export default usePageGround
